/* eslint-disable @typescript-eslint/no-explicit-any */
import BattleReportComponent from 'components/marketingSite/battleReport/BattleReportComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useRouter } from 'next/dist/client/router';
import { useEffect, useState } from 'react';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type BattleReportPageProps = {
  baseUrl?: string;
};

const parseJSON = (resp: any): any => (resp.json ? resp.json() : resp);

const checkStatus = (resp: any): any => {
  if (resp.status >= 200 && resp.status < 300) {
    return resp;
  }

  return parseJSON(resp).then((resp: any) => {
    throw resp;
  });
};

const headers = { 'Content-Type': 'application/json' };

const BattleReportPage: React.FC<BattleReportPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('battle-report');

  usePageTrack('Landing - Page Loaded');

  const { locale } = useRouter();

  const [warReportsSales, setWarReportsSales] = useState([]);
  const [warReportsGoals, setWarReportsGoals] = useState([]);

  useEffect(() => {
    fetch(`https://cms.getmanfred.com/api/war-reports-sales`, {
      headers,
      method: 'GET'
    })
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setWarReportsSales(data));
  }, []);

  useEffect(() => {
    fetch(
      `https://cms.getmanfred.com/api/war-report-goals?populate=%2A&pagination[pageSize]=100&locale=${locale}`,
      {
        headers,
        method: 'GET'
      }
    )
      .then(checkStatus)
      .then(parseJSON)
      .then(({ data }) => setWarReportsGoals(data));
  }, [locale]);

  return (
    <>
      <HeadMetadata
        title={t('battle-report.page_title')}
        url={APP_URLS.battleReport}
        desc={t('battle-report.page_description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_battle_report.png'
        )}`}
        extraMeta={<meta name="robots" content="noindex,follow" />}
      />
      <BattleReportComponent sales={warReportsSales} goals={warReportsGoals} />
    </>
  );
};

export default BattleReportPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'battle-report'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
